
import { v4 } from "uuid";
import {
    resolveOriginalInPrice,
    resolveOriginalOutPrice,
    resolveOriginalPrice
} from "@/lib/comboMealPriceUtils";

function BackendToCartDataFormat(backendData){

    console.clear();
    console.log(backendData)
    let orderType = "";
    let customer = null;
    let delivery = null;
    let cart = [];

    if(backendData?.order_type){

        if(backendData?.order_type == "pickup"){
            orderType = "Pickup"
        }
        else if(backendData?.order_type == "in_house"){
            orderType = "in_house"
        }
        else if(backendData?.order_type == "delivery"){
            orderType = "Delivery"
        }
        else if(backendData?.order_type == "table"){
            orderType = "Table"
        }
    }

    if (backendData?.customer) {
        customer = {
            ...backendData.customer,
            id: backendData.customer.id ?? backendData.customer_id ?? null,
            full_name: backendData.customer.full_name || backendData.customer_full_name || backendData.customer_name || "",
            number: backendData.customer.number || backendData.customer_number || "",
            postal_code: backendData.customer.postal_code || backendData.customer_postal_code || "",
        };
    } else if (backendData?.customer_full_name || backendData?.customer_number || backendData?.customer_name || backendData?.customer_id) {
        customer = {
            id: backendData?.customer_id || null,
            full_name: backendData?.customer_full_name || backendData?.customer_name || "",
            number: backendData?.customer_number || "",
            postal_code: backendData?.customer_postal_code || "",
        };
    }

    if(backendData?.delivery){
        delivery = backendData?.delivery || null;
    }


    backendData?.items?.forEach((data)=>{
        let cartData = {};
        cartData.id = v4();
        cartData.quantity = data?.quantity || 1;

        cartData.extraAddon = data?.extra_addons.map(extraAddonData=>{
            let extraAddon = {id: null, data: {addon: {}}};
            extraAddon.id = v4();
            extraAddon.addon = {id: extraAddonData?.id || null, name: extraAddonData?.name || "", price: extraAddonData?.price || 0};
            return extraAddon;
        }) || [];

        cartData.modifiers = data?.modifiers.map(modData=>{
            let modifierData = {id: null, data: {modifier: {}, preFix: ""}};
            modifierData.id = v4();
            modifierData.data.modifier = {id: modData?.id || null, name: modData?.name || ""};
            modifierData.data.preFix = modData?.preFix || "";
            return modifierData;
        
        }) || [];

        cartData.extraToppings = data?.extra_toppings.map(extraToppingData=>{
            let extraTopping = {id: null, data: {topping: {}}};
            extraTopping.id = v4();
            extraTopping.topping = {id: extraToppingData?.id || null, name: extraToppingData?.name || "", price: extraToppingData?.price || 0};
            return extraTopping;
        }) || [];

        cartData.extraSauces = data?.extra_sauces.map(extraSauceData=>{
            let extraSauce = {id: null, data: {sauce: {}}};
            extraSauce.id = v4();
            extraSauce.sauce = {id: extraSauceData?.id || null, name: extraSauceData?.name || "", price: extraSauceData?.price || 0};
            return extraSauce;
        }) || [];

        cartData.extraSalads = data?.extra_salads.map(extraSaladData=>{
            let extraSalad = {id: null, data: {salad: {}}};
            extraSalad.id = v4();
            extraSalad.salad = {id: extraSaladData?.id || null, name: extraSaladData?.name || "", price: extraSaladData?.price || 0};
            return extraSalad;
        }) || [];

        cartData.buffetPriceFor = data?.buffet_price_for == "adult"? "Adult" : "Kid";

        cartData.data   = {};
        cartData.data.item = {};
        cartData.data.item.id = data?.id || null;
        cartData.data.item.name = data?.name || "";
        cartData.data.item.menu_item_id = data?.menu_item_id ? Number(data.menu_item_id) : null;
        cartData.data.item.order_item_id = data?.order_item_id || null;
        cartData.data.item.price = data?.price ?? (data?.calculated_price != null ? Number(data.calculated_price) : undefined);
        cartData.data.item.in_price = data?.in_price;
        cartData.data.item.out_price = data?.out_price;
        cartData.data.item.adult_price = data?.adult_price;
        cartData.data.item.kids_price = data?.kids_price;
        cartData.data.item.variants = data?.variants || [];
        cartData.data.item.add_ons = data?.addons || [];
        cartData.data.item.salads = data?.salads || [];
        cartData.data.item.sauces = data?.sauces || [];
        cartData.data.item.toppings = data?.toppings || [];
        cartData.data.item.modifiers = data?.modifiers || [];
        cartData.data.item.vat = Number.parseFloat(data?.orginal_vat_percent || 0).toFixed(2);

        if(data?.is_custom_pizza || Number(data?.menu_item_id) === 22){
            const customPizzaInfo = data?.custom_pizza || {};
            const resolvedBase = data?.base || (customPizzaInfo?.base_id ? {
                id: customPizzaInfo.base_id,
                name: customPizzaInfo.base_name || "Classic Tomato",
                price: Number(customPizzaInfo.base_price || 0)
            } : null);

            const resolvedCrust = data?.crust || (customPizzaInfo?.crust_id ? {
                id: customPizzaInfo.crust_id,
                name: customPizzaInfo.crust_name || "Thin Crust",
                price: Number(customPizzaInfo.crust_price || 0)
            } : null);

            const resolvedToppings = data?.toppings || [];
            const resolvedAddons = data?.add_ons || data?.addons || [];
            const resolvedModifiers = data?.modifiers || [];
            const resolvedAllergens = data?.allergens || [];

            const fallbackPrice = (
                Number(resolvedBase?.price || 0) +
                Number(resolvedCrust?.price || 0) +
                resolvedToppings.reduce((s, t) => s + Number(t?.price || 0), 0) +
                resolvedAddons.reduce((s, a) => s + Number(a?.price || 0), 0)
            );

            const resolvedUnitPrice = Number(
                data?.calculated_price ??
                data?.price ??
                data?.unit_price ??
                fallbackPrice ??
                0
            );

            cartData.isCustomPizza = true;
            cartData.unitPrice = resolvedUnitPrice;
            cartData.customPizzaData = {
                base: resolvedBase,
                crust: resolvedCrust,
                toppings: resolvedToppings,
                add_ons: resolvedAddons,
                modifiers: resolvedModifiers,
                allergens: resolvedAllergens,
                unitPrice: resolvedUnitPrice
            };
            cartData.data.item.is_custom_pizza = true;
            cartData.data.item.price = resolvedUnitPrice;
            cartData.data.item.in_price = resolvedUnitPrice;
            cartData.data.item.out_price = resolvedUnitPrice;
            cartData.data.item.calculated_price = resolvedUnitPrice;
            cartData.data.item.base = resolvedBase;
            cartData.data.item.crust = resolvedCrust;
            cartData.data.item.toppings = resolvedToppings;
            cartData.data.item.add_ons = resolvedAddons;
            cartData.data.item.modifiers = resolvedModifiers;
            cartData.data.item.allergens = resolvedAllergens;
            if (data?.vat != null) {
                cartData.data.item.vat_amount = Number(data.vat);
            }
            if (resolvedBase || resolvedCrust) {
                cartData.data.variant = {
                    name: `${resolvedCrust?.name || "Standard Crust"} + ${resolvedBase?.name || "Standard Base"}`,
                    price: resolvedUnitPrice,
                    in_price: resolvedUnitPrice,
                    out_price: resolvedUnitPrice
                };
            }
        }
        // Extract full banquet / Choose Your Own extra items and courses
        // Priority: data.create_your_own_general / data.banquet (complete definition) -> data.extra_items/courses -> cached definition -> banquet_extra_items
        let cachedBanquetItem = null;
        try {
            const storageKey = Number(data?.menu_item_id) === 21 ? "create_your_own_general_menu_items" : "banquet_menu_items";
            const raw = typeof window !== "undefined" && window?.sessionStorage ? sessionStorage.getItem(storageKey) : null;
            if (raw) {
                const parsed = JSON.parse(raw);
                if (Array.isArray(parsed)) {
                    cachedBanquetItem = parsed.find(bi => String(bi.id) === String(data?.id) || bi?.name === data?.name);
                }
            }
        } catch (e) {
            // ignore
        }

        const allExtraItems = (Array.isArray(data?.create_your_own_general?.extra_items) && data.create_your_own_general.extra_items.length > 0)
            ? data.create_your_own_general.extra_items
            : ((Array.isArray(data?.banquet?.extra_items) && data.banquet.extra_items.length > 0)
            ? data.banquet.extra_items
            : ((Array.isArray(data?.extra_items) && data.extra_items.length > 0)
                ? data.extra_items
                : (cachedBanquetItem?.extra_items && cachedBanquetItem.extra_items.length > 0
                    ? cachedBanquetItem.extra_items
                    : (data?.banquet_extra_items || []))));

        const allCourses = (Array.isArray(data?.create_your_own_general?.courses) && data.create_your_own_general.courses.length > 0)
            ? data.create_your_own_general.courses
            : ((Array.isArray(data?.banquet?.courses) && data.banquet.courses.length > 0)
            ? data.banquet.courses
            : ((Array.isArray(data?.courses) && data.courses.length > 0)
                ? data.courses
                : (cachedBanquetItem?.courses || [])));

        cartData.data.item.extra_items = allExtraItems;
        cartData.data.item.courses = allCourses;
        cartData.data.item.banquet_extra_price = Number(data?.banquet_extra_price || 0);
        cartData.data.item.calculated_price = data?.calculated_price != null ? Number(data.calculated_price) : null;
        if (data?.banquet?.days) cartData.data.item.days = data.banquet.days;
        if (data?.banquet?.person_limit) cartData.data.item.person_limit = data.banquet.person_limit;
        if (data?.create_your_own_general?.days) cartData.data.item.days = data.create_your_own_general.days;
        if (data?.create_your_own_general?.person_limit) cartData.data.item.person_limit = data.create_your_own_general.person_limit;

        // Format banquet / Choose Your Own selected course items
        const rawSelectedCourseItems = (Array.isArray(data?.selected_course_item) && data.selected_course_item.length > 0)
            ? data.selected_course_item
            : ((Array.isArray(data?.create_your_own_general_selected_items) && data.create_your_own_general_selected_items.length > 0)
                ? data.create_your_own_general_selected_items
                : ((Array.isArray(data?.selectedCreateYourOwnGeneralCourseItem) && data.selectedCreateYourOwnGeneralCourseItem.length > 0)
                    ? data.selectedCreateYourOwnGeneralCourseItem
                    : ((Array.isArray(data?.selected_create_your_own_general_course_items) && data.selected_create_your_own_general_course_items.length > 0)
                        ? data.selected_create_your_own_general_course_items
                        : ((Array.isArray(data?.selectedBanquetCourseItem) && data.selectedBanquetCourseItem.length > 0)
                            ? data.selectedBanquetCourseItem
                            : ((Array.isArray(data?.banquet_selected_items) && data.banquet_selected_items.length > 0)
                                ? data.banquet_selected_items
                                : [])))));

        if (Array.isArray(data?.selected_course_item) && data.selected_course_item.length > 0) {
            cartData.selectedCourseItem = data.selected_course_item;
        } else if (rawSelectedCourseItems.length > 0) {
            const courseMap = new Map();

            // Pre-seed courses from complete banquet / general definition to preserve ordering and proper names
            if (Array.isArray(allCourses) && allCourses.length > 0) {
                allCourses.forEach(c => {
                    courseMap.set(String(c.id), {
                        id: c.id,
                        name: c.name,
                        max_selections: c.max_selections || 1,
                        course_items: []
                    });
                });
            }

            let flattenedSelectedItems = [];
            if (Array.isArray(rawSelectedCourseItems)) {
                rawSelectedCourseItems.forEach((entry) => {
                    if (entry && Array.isArray(entry.items)) {
                        const courseId = entry.id;
                        entry.items.forEach((subItem) => {
                            flattenedSelectedItems.push({
                                ...subItem,
                                create_your_own_general_course_id: subItem.create_your_own_general_course_id || courseId,
                                banquet_course_id: subItem.banquet_course_id || courseId,
                            });
                        });
                    } else if (entry) {
                        flattenedSelectedItems.push(entry);
                    }
                });
            }

            flattenedSelectedItems.forEach((bItem) => {
                const courseId = String(bItem.create_your_own_general_course_id || bItem.banquet_course_id || bItem.course_id || bItem.course?.id || "default");
                if (!courseMap.has(courseId)) {
                    const courseName = bItem.create_your_own_general_course?.name
                        || bItem.banquet_course?.name 
                        || bItem.course?.name 
                        || bItem.course_name 
                        || bItem.banquet_course_name 
                        || `Course ${courseMap.size + 1}`;

                    courseMap.set(courseId, {
                        id: bItem.create_your_own_general_course_id || bItem.banquet_course_id || courseId,
                        name: courseName,
                        max_selections: bItem.create_your_own_general_course?.max_selections || bItem.banquet_course?.max_selections || 1,
                        course_items: []
                    });
                }
                const courseObj = courseMap.get(courseId);
                const itemName = bItem.display_name || bItem.name || bItem.menu_item?.name || "Item";

                const rawModifiers = Array.isArray(bItem.modifiers) ? bItem.modifiers : [];
                const normalizedModifiers = rawModifiers.map((m) => {
                    if (m?.data?.modifier) {
                        return {
                            id: m.id || v4(),
                            data: {
                                modifier: m.data.modifier,
                                preFix: m.data.preFix || m.preFix || ""
                            }
                        };
                    }
                    return {
                        id: m?.id || v4(),
                        data: {
                            modifier: {
                                id: m?.modifier_id || m?.id,
                                name: m?.name || m?.modifier?.name || ""
                            },
                            preFix: m?.preFix || ""
                        }
                    };
                });

                const rawExtraAddons = Array.isArray(bItem.extra_addons)
                    ? bItem.extra_addons
                    : (Array.isArray(bItem.extraAddon) ? bItem.extraAddon : []);
                const normalizedExtraAddons = rawExtraAddons.map((a) => {
                    if (a?.addon) return a;
                    return { id: a?.id || v4(), addon: a };
                });

                const rawExtraToppings = Array.isArray(bItem.extra_toppings)
                    ? bItem.extra_toppings
                    : (Array.isArray(bItem.extraToppings) ? bItem.extraToppings : []);
                const normalizedExtraToppings = rawExtraToppings.map((t) => {
                    if (t?.topping) return t;
                    return { id: t?.id || v4(), topping: t };
                });

                const rawExtraSauces = Array.isArray(bItem.extra_sauces)
                    ? bItem.extra_sauces
                    : (Array.isArray(bItem.extraSauces) ? bItem.extraSauces : []);
                const normalizedExtraSauces = rawExtraSauces.map((s) => {
                    if (s?.sauce) return s;
                    return { id: s?.id || v4(), sauce: s };
                });

                const rawExtraSalads = Array.isArray(bItem.extra_salads)
                    ? bItem.extra_salads
                    : (Array.isArray(bItem.extraSalads) ? bItem.extraSalads : []);
                const normalizedExtraSalads = rawExtraSalads.map((sl) => {
                    if (sl?.salad) return sl;
                    return { id: sl?.id || v4(), salad: sl };
                });

                courseObj.course_items.push({
                    id: bItem.id || v4(),
                    course_item_unique_id: bItem.course_item_unique_id || bItem.unique_id || v4(),
                    item_id: bItem.item_id || bItem.menu_item?.id || bItem.id,
                    item_type: bItem.item_type || null,
                    menu_item_id: bItem.menu_item_id || null,
                    variant_id: bItem.variant_id || bItem.variant?.id || null,
                    quantity: Number(bItem.quantity || 1),
                    price: Number(bItem.price || 0),
                    display_name: itemName,
                    name: itemName,
                    menu_item: bItem.menu_item || {
                        id: bItem.item_id || bItem.id,
                        name: itemName,
                        price: Number(bItem.price || 0)
                    },
                    variant: bItem.variant || (bItem.variant_id ? { id: bItem.variant_id, name: bItem.variant_name || "" } : null),
                    banquet_course_id: bItem.banquet_course_id,
                    create_your_own_general_course_id: bItem.create_your_own_general_course_id,
                    is_replaced: Boolean(bItem.is_replaced),
                    original_item: bItem.original_item || null,
                    price_difference: bItem.price_difference,
                    replacement_extra_price: bItem.replacement_extra_price,
                    replacement_extra_in_price: bItem.replacement_extra_in_price,
                    replacement_extra_out_price: bItem.replacement_extra_out_price,
                    defaultAddons: bItem.defaultAddons || bItem.add_ons || bItem.addons || [],
                    defaultSauces: bItem.defaultSauces || bItem.sauces || [],
                    defaultSalads: bItem.defaultSalads || bItem.salads || [],
                    defaultToppings: bItem.defaultToppings || bItem.toppings || [],
                    extraAddon: normalizedExtraAddons,
                    extraToppings: normalizedExtraToppings,
                    extraSauces: normalizedExtraSauces,
                    extraSalads: normalizedExtraSalads,
                    modifiers: normalizedModifiers
                });
            });

            cartData.selectedCourseItem = Array.from(courseMap.values());
        } else if ((data?.menu_item_id == 16 || data?.menu_item_id == 21 || cartData.data.item.menu_item_id == 16 || cartData.data.item.menu_item_id == 21) && Array.isArray(allCourses) && allCourses.length > 0) {
            // Default select first items up to max_selections if none selected yet
            cartData.selectedCourseItem = allCourses.map(course => ({
                ...course,
                course_items: Array.isArray(course?.course_items) ? course.course_items.slice(0, course?.max_selections || 1) : []
            }));
        } else {
            cartData.selectedCourseItem = data?.selected_course_item || null;
        }

        if (data?.combo_items && Array.isArray(data.combo_items)) {
            cartData.data.item.combo_items = data.combo_items.map((ci) => {
                const rawModifiers = Array.isArray(ci.modifiers) ? ci.modifiers : [];
                const normalizedModifiers = rawModifiers.map((m) => {
                    if (m?.data?.modifier) {
                        return {
                            id: m.id || v4(),
                            data: {
                                modifier: m.data.modifier,
                                preFix: m.data.preFix || m.preFix || ""
                            }
                        };
                    }
                    return {
                        id: m.id || v4(),
                        data: {
                            modifier: { id: m.id, name: m.name, ...m },
                            preFix: m.preFix || m.prefix || ""
                        }
                    };
                });

                const rawExtraAddons = Array.isArray(ci.extraAddon) ? ci.extraAddon : (Array.isArray(ci.extra_addons) ? ci.extra_addons : []);
                const normalizedExtraAddons = rawExtraAddons.map((ea) => {
                    if (ea?.addon) return ea;
                    return {
                        id: ea.unique_id || v4(),
                        addon: { id: ea.id, name: ea.name, price: Number(ea.price || 0), ...ea }
                    };
                });

                const rawExtraToppings = Array.isArray(ci.extraToppings) ? ci.extraToppings : (Array.isArray(ci.extra_toppings) ? ci.extra_toppings : []);
                const normalizedExtraToppings = rawExtraToppings.map((et) => {
                    if (et?.topping) return et;
                    return {
                        id: et.unique_id || v4(),
                        topping: { id: et.id, name: et.name, price: Number(et.price || 0), ...et }
                    };
                });

                const rawExtraSauces = Array.isArray(ci.extraSauces) ? ci.extraSauces : (Array.isArray(ci.extra_sauces) ? ci.extra_sauces : []);
                const normalizedExtraSauces = rawExtraSauces.map((es) => {
                    if (es?.sauce) return es;
                    return {
                        id: es.unique_id || v4(),
                        sauce: { id: es.id, name: es.name, price: Number(es.price || 0), ...es }
                    };
                });

                const rawExtraSalads = Array.isArray(ci.extraSalads) ? ci.extraSalads : (Array.isArray(ci.extra_salads) ? ci.extra_salads : []);
                const normalizedExtraSalads = rawExtraSalads.map((es) => {
                    if (es?.salad) return es;
                    return {
                        id: es.unique_id || v4(),
                        salad: { id: es.id, name: es.name, price: Number(es.price || 0), ...es }
                    };
                });

                const rawDefaultAddons = Array.isArray(ci.defaultAddons) ? ci.defaultAddons : (Array.isArray(ci.add_ons) ? ci.add_ons : []);
                const normalizedDefaultAddons = rawDefaultAddons.map((a) => ({
                    ...a,
                    canceled: Boolean(a.canceled || a.is_canceled)
                }));

                const rawDefaultSauces = Array.isArray(ci.defaultSauces) ? ci.defaultSauces : (Array.isArray(ci.sauces) ? ci.sauces : []);
                const normalizedDefaultSauces = rawDefaultSauces.map((s) => ({
                    ...s,
                    canceled: Boolean(s.canceled || s.is_canceled)
                }));

                const rawDefaultSalads = Array.isArray(ci.defaultSalads) ? ci.defaultSalads : (Array.isArray(ci.salads) ? ci.salads : []);
                const normalizedDefaultSalads = rawDefaultSalads.map((sl) => ({
                    ...sl,
                    canceled: Boolean(sl.canceled || sl.is_canceled)
                }));

                const rawDefaultToppings = Array.isArray(ci.defaultToppings) ? ci.defaultToppings : (Array.isArray(ci.toppings) ? ci.toppings : []);
                const normalizedDefaultToppings = rawDefaultToppings.map((t) => ({
                    ...t,
                    canceled: Boolean(t.canceled || t.is_canceled)
                }));

                const itemName =
                    ci.display_name ||
                    ci.name ||
                    ci.item_name ||
                    ci.menu_item?.name ||
                    (ci.item_type ? ci.item_type.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase()) : "Item");

                const origIn = resolveOriginalInPrice(ci);
                const origOut = resolveOriginalOutPrice(ci);
                const origPrice = resolveOriginalPrice(ci);

                const rawOriginalItem = ci.original_item || ci.replacement_details?.original_item || null;
                const parsedOriginalItem = rawOriginalItem ? {
                    ...rawOriginalItem,
                    id: rawOriginalItem.item_id || rawOriginalItem.id || ci.original_item_id || null,
                    menu_item_id: rawOriginalItem.menu_item_id ? Number(rawOriginalItem.menu_item_id) : (ci.original_menu_item_id ? Number(ci.original_menu_item_id) : null),
                    item_type: rawOriginalItem.item_type || ci.original_item_type || null,
                    in_price: origIn,
                    out_price: origOut,
                    price: origPrice,
                    original_in_price: origIn,
                    original_out_price: origOut,
                    original_price: origPrice
                } : null;

                const isReplaced = Boolean(ci.is_replaced || ci.replacement_details?.is_replaced);
                const rawReplacementItem = ci.replacement_item || ci.replacement_details?.replacement_item || null;

                const repIn = Number(
                    ci.replacement_in_price ??
                    rawReplacementItem?.in_price ??
                    rawReplacementItem?.price ??
                    (isReplaced ? (ci.in_price ?? ci.variant?.in_price ?? ci.price) : 0) ??
                    0
                );

                const repOut = Number(
                    ci.replacement_out_price ??
                    rawReplacementItem?.out_price ??
                    rawReplacementItem?.price ??
                    (isReplaced ? (ci.out_price ?? ci.variant?.out_price ?? ci.price) : 0) ??
                    0
                );

                const isTableOrder = backendData?.order_type === "table";

                const rawInDiff = ci.replacement_extra_in_price ?? ci.replacement_details?.price_difference?.in_price_diff;
                const resolvedInDiff = rawInDiff != null
                    ? Number(rawInDiff)
                    : (isReplaced
                        ? ((repIn > 0 && origIn > 0) ? Math.max(0, repIn - origIn) : Number(ci.price_difference || 0))
                        : 0);

                const rawOutDiff = ci.replacement_extra_out_price ?? ci.replacement_details?.price_difference?.out_price_diff;
                const resolvedOutDiff = rawOutDiff != null
                    ? Number(rawOutDiff)
                    : (isReplaced
                        ? ((repOut > 0 && origOut > 0) ? Math.max(0, repOut - origOut) : Number(ci.price_difference || 0))
                        : 0);

                const rawExtraPrice = ci.replacement_extra_price ?? ci.replacement_details?.extra_price ?? ci.price_difference;
                const resolvedExtraPrice = rawExtraPrice != null
                    ? Number(rawExtraPrice)
                    : (isTableOrder ? resolvedInDiff : resolvedOutDiff);

                const resolvedMenuItemId = ci.menu_item_id
                    ? Number(ci.menu_item_id)
                    : (ci.replacement_details?.replacement_item?.menu_item_id
                        ? Number(ci.replacement_details.replacement_item.menu_item_id)
                        : (rawReplacementItem?.menu_item_id
                            ? Number(rawReplacementItem.menu_item_id)
                            : (ci.replacement_menu_item_id ? Number(ci.replacement_menu_item_id) : null)));

                const parsedReplacementItem = rawReplacementItem ? {
                    ...rawReplacementItem,
                    id: rawReplacementItem.item_id || rawReplacementItem.id || ci.item_id || null,
                    menu_item_id: rawReplacementItem.menu_item_id ? Number(rawReplacementItem.menu_item_id) : resolvedMenuItemId,
                    item_type: rawReplacementItem.item_type || ci.item_type || null,
                    in_price: repIn,
                    out_price: repOut,
                    price: isTableOrder ? repIn : repOut,
                    variant: rawReplacementItem.variant || (rawReplacementItem.variant_id ? { id: rawReplacementItem.variant_id, name: rawReplacementItem.variant_name || "" } : null)
                } : null;

                return {
                    ...ci,
                    combo_item_unique_id: ci.combo_item_unique_id || v4(),
                    menu_item_id: resolvedMenuItemId,
                    item_type: ci.item_type || ci.replacement_details?.replacement_item?.item_type || ci.replacement_item_type || null,
                    display_name: itemName,
                    name: itemName,
                    menu_item: ci.menu_item || {
                        id: ci.item_id || ci.id,
                        name: itemName,
                        add_ons: normalizedDefaultAddons,
                        sauces: normalizedDefaultSauces,
                        salads: normalizedDefaultSalads,
                        toppings: normalizedDefaultToppings
                    },
                    variant: ci.variant || (ci.variant_id ? { id: ci.variant_id, name: ci.variant_name || "" } : null),
                    extraAddon: normalizedExtraAddons,
                    modifiers: normalizedModifiers,
                    extraToppings: normalizedExtraToppings,
                    extraSauces: normalizedExtraSauces,
                    extraSalads: normalizedExtraSalads,
                    is_replaced: isReplaced,
                    replacement_item: parsedReplacementItem,
                    replacement_in_price: repIn,
                    replacement_out_price: repOut,
                    replacement_extra_in_price: resolvedInDiff,
                    replacement_extra_out_price: resolvedOutDiff,
                    replacement_extra_price: resolvedExtraPrice,
                    price_difference: resolvedExtraPrice,
                    original_item: parsedOriginalItem,
                    original_in_price: origIn,
                    original_out_price: origOut,
                    original_price: origPrice,
                    defaultAddons: normalizedDefaultAddons,
                    defaultSauces: normalizedDefaultSauces,
                    defaultSalads: normalizedDefaultSalads,
                    defaultToppings: normalizedDefaultToppings
                };
            });
        }

        if (data?.course_items && Array.isArray(data.course_items)) {
            cartData.data.item.course_items = data.course_items.map((ci) => {
                const rawModifiers = Array.isArray(ci.modifiers) ? ci.modifiers : [];
                const normalizedModifiers = rawModifiers.map((m) => {
                    if (m?.data?.modifier) {
                        return {
                            id: m.id || v4(),
                            data: {
                                modifier: m.data.modifier,
                                preFix: m.data.preFix || m.preFix || ""
                            }
                        };
                    }
                    return {
                        id: m.id || v4(),
                        data: {
                            modifier: { id: m.id, name: m.name, ...m },
                            preFix: m.preFix || m.prefix || ""
                        }
                    };
                });

                const rawExtraAddons = Array.isArray(ci.extraAddon) ? ci.extraAddon : (Array.isArray(ci.extra_addons) ? ci.extra_addons : []);
                const normalizedExtraAddons = rawExtraAddons.map((ea) => {
                    if (ea?.addon) return ea;
                    return {
                        id: ea.unique_id || v4(),
                        addon: { id: ea.id, name: ea.name, price: Number(ea.price || 0), ...ea }
                    };
                });

                const rawExtraToppings = Array.isArray(ci.extraToppings) ? ci.extraToppings : (Array.isArray(ci.extra_toppings) ? ci.extra_toppings : []);
                const normalizedExtraToppings = rawExtraToppings.map((et) => {
                    if (et?.topping) return et;
                    return {
                        id: et.unique_id || v4(),
                        topping: { id: et.id, name: et.name, price: Number(et.price || 0), ...et }
                    };
                });

                const rawExtraSauces = Array.isArray(ci.extraSauces) ? ci.extraSauces : (Array.isArray(ci.extra_sauces) ? ci.extra_sauces : []);
                const normalizedExtraSauces = rawExtraSauces.map((es) => {
                    if (es?.sauce) return es;
                    return {
                        id: es.unique_id || v4(),
                        sauce: { id: es.id, name: es.name, price: Number(es.price || 0), ...es }
                    };
                });

                const rawExtraSalads = Array.isArray(ci.extraSalads) ? ci.extraSalads : (Array.isArray(ci.extra_salads) ? ci.extra_salads : []);
                const normalizedExtraSalads = rawExtraSalads.map((es) => {
                    if (es?.salad) return es;
                    return {
                        id: es.unique_id || v4(),
                        salad: { id: es.id, name: es.name, price: Number(es.price || 0), ...es }
                    };
                });

                const rawDefaultAddons = Array.isArray(ci.defaultAddons) ? ci.defaultAddons : (Array.isArray(ci.add_ons) ? ci.add_ons : []);
                const normalizedDefaultAddons = rawDefaultAddons.map((a) => ({
                    ...a,
                    canceled: Boolean(a.canceled || a.is_canceled)
                }));

                const rawDefaultSauces = Array.isArray(ci.defaultSauces) ? ci.defaultSauces : (Array.isArray(ci.sauces) ? ci.sauces : []);
                const normalizedDefaultSauces = rawDefaultSauces.map((s) => ({
                    ...s,
                    canceled: Boolean(s.canceled || s.is_canceled)
                }));

                const rawDefaultSalads = Array.isArray(ci.defaultSalads) ? ci.defaultSalads : (Array.isArray(ci.salads) ? ci.salads : []);
                const normalizedDefaultSalads = rawDefaultSalads.map((sl) => ({
                    ...sl,
                    canceled: Boolean(sl.canceled || sl.is_canceled)
                }));

                const rawDefaultToppings = Array.isArray(ci.defaultToppings) ? ci.defaultToppings : (Array.isArray(ci.toppings) ? ci.toppings : []);
                const normalizedDefaultToppings = rawDefaultToppings.map((t) => ({
                    ...t,
                    canceled: Boolean(t.canceled || t.is_canceled)
                }));

                const itemName =
                    ci.display_name ||
                    ci.name ||
                    ci.item_name ||
                    ci.menu_item?.name ||
                    (ci.item_type ? ci.item_type.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase()) : "Item");

                const origIn = resolveOriginalInPrice(ci);
                const origOut = resolveOriginalOutPrice(ci);
                const origPrice = resolveOriginalPrice(ci);

                const rawOriginalItem = ci.original_item || ci.replacement_details?.original_item || null;
                const parsedOriginalItem = rawOriginalItem ? {
                    ...rawOriginalItem,
                    id: rawOriginalItem.item_id || rawOriginalItem.id || ci.original_item_id || null,
                    menu_item_id: rawOriginalItem.menu_item_id ? Number(rawOriginalItem.menu_item_id) : (ci.original_menu_item_id ? Number(ci.original_menu_item_id) : null),
                    item_type: rawOriginalItem.item_type || ci.original_item_type || null,
                    in_price: origIn,
                    out_price: origOut,
                    price: origPrice,
                    original_in_price: origIn,
                    original_out_price: origOut,
                    original_price: origPrice
                } : null;

                const isReplaced = Boolean(ci.is_replaced || ci.replacement_details?.is_replaced);
                const rawReplacementItem = ci.replacement_item || ci.replacement_details?.replacement_item || null;

                const repIn = Number(
                    ci.replacement_in_price ??
                    rawReplacementItem?.in_price ??
                    rawReplacementItem?.price ??
                    (isReplaced ? (ci.in_price ?? ci.variant?.in_price ?? ci.price) : 0) ??
                    0
                );

                const repOut = Number(
                    ci.replacement_out_price ??
                    rawReplacementItem?.out_price ??
                    rawReplacementItem?.price ??
                    (isReplaced ? (ci.out_price ?? ci.variant?.out_price ?? ci.price) : 0) ??
                    0
                );

                const isTableOrder = backendData?.order_type === "table";

                const rawInDiff = ci.replacement_extra_in_price ?? ci.replacement_details?.price_difference?.in_price_diff;
                const resolvedInDiff = rawInDiff != null
                    ? Number(rawInDiff)
                    : (isReplaced
                        ? ((repIn > 0 && origIn > 0) ? Math.max(0, repIn - origIn) : Number(ci.price_difference || 0))
                        : 0);

                const rawOutDiff = ci.replacement_extra_out_price ?? ci.replacement_details?.price_difference?.out_price_diff;
                const resolvedOutDiff = rawOutDiff != null
                    ? Number(rawOutDiff)
                    : (isReplaced
                        ? ((repOut > 0 && origOut > 0) ? Math.max(0, repOut - origOut) : Number(ci.price_difference || 0))
                        : 0);

                const rawExtraPrice = ci.replacement_extra_price ?? ci.replacement_details?.extra_price ?? ci.price_difference;
                const resolvedExtraPrice = rawExtraPrice != null
                    ? Number(rawExtraPrice)
                    : (isTableOrder ? resolvedInDiff : resolvedOutDiff);

                const resolvedMenuItemId = ci.menu_item_id
                    ? Number(ci.menu_item_id)
                    : (ci.replacement_details?.replacement_item?.menu_item_id
                        ? Number(ci.replacement_details.replacement_item.menu_item_id)
                        : (rawReplacementItem?.menu_item_id
                            ? Number(rawReplacementItem.menu_item_id)
                            : (ci.replacement_menu_item_id ? Number(ci.replacement_menu_item_id) : null)));

                const parsedReplacementItem = rawReplacementItem ? {
                    ...rawReplacementItem,
                    id: rawReplacementItem.item_id || rawReplacementItem.id || ci.item_id || null,
                    menu_item_id: rawReplacementItem.menu_item_id ? Number(rawReplacementItem.menu_item_id) : resolvedMenuItemId,
                    item_type: rawReplacementItem.item_type || ci.item_type || null,
                    in_price: repIn,
                    out_price: repOut,
                    price: isTableOrder ? repIn : repOut,
                    variant: rawReplacementItem.variant || (rawReplacementItem.variant_id ? { id: rawReplacementItem.variant_id, name: rawReplacementItem.variant_name || "" } : null)
                } : null;

                return {
                    ...ci,
                    course_item_unique_id: ci.course_item_unique_id || v4(),
                    menu_item_id: resolvedMenuItemId,
                    item_type: ci.item_type || ci.replacement_details?.replacement_item?.item_type || ci.replacement_item_type || null,
                    display_name: itemName,
                    name: itemName,
                    menu_item: ci.menu_item || {
                        id: ci.item_id || ci.id,
                        name: itemName,
                        add_ons: normalizedDefaultAddons,
                        sauces: normalizedDefaultSauces,
                        salads: normalizedDefaultSalads,
                        toppings: normalizedDefaultToppings
                    },
                    variant: ci.variant || (ci.variant_id ? { id: ci.variant_id, name: ci.variant_name || "" } : null),
                    extraAddon: normalizedExtraAddons,
                    modifiers: normalizedModifiers,
                    extraToppings: normalizedExtraToppings,
                    extraSauces: normalizedExtraSauces,
                    extraSalads: normalizedExtraSalads,
                    is_replaced: isReplaced,
                    replacement_item: parsedReplacementItem,
                    replacement_in_price: repIn,
                    replacement_out_price: repOut,
                    replacement_extra_in_price: resolvedInDiff,
                    replacement_extra_out_price: resolvedOutDiff,
                    replacement_extra_price: resolvedExtraPrice,
                    price_difference: resolvedExtraPrice,
                    original_item: parsedOriginalItem,
                    original_in_price: origIn,
                    original_out_price: origOut,
                    original_price: origPrice,
                    defaultAddons: normalizedDefaultAddons,
                    defaultSauces: normalizedDefaultSauces,
                    defaultSalads: normalizedDefaultSalads,
                    defaultToppings: normalizedDefaultToppings
                };
            });
        }

        if (Number(data?.menu_item_id) === 20 || data?.mix_and_match_items || data?.selected_items) {
            let flatSelectedItems = [];
            const rawSelected = data?.mix_and_match_items || data?.selected_items || [];

            if (Array.isArray(rawSelected)) {
                rawSelected.forEach((entry) => {
                    if (Array.isArray(entry?.items)) {
                        entry.items.forEach((subItem) => {
                            flatSelectedItems.push({
                                category_id: entry.category_id || entry.id,
                                category_name: entry.category_name || "",
                                category_price: Number(entry.price ?? entry.category_price ?? 0),
                                item_id: subItem.item_id || subItem.id,
                                item_name: subItem.name || subItem.item_name || "Item",
                                quantity: Number(subItem.quantity || 1)
                            });
                        });
                    } else if (entry) {
                        flatSelectedItems.push({
                            category_id: entry.category_id || entry.id,
                            category_name: entry.category_name || "",
                            category_price: Number(entry.category_price ?? entry.price ?? 0),
                            item_id: entry.item_id || entry.id,
                            item_name: entry.item_name || entry.name || "Item",
                            quantity: Number(entry.quantity || 1)
                        });
                    }
                });
            }

            cartData.selectedMixAndMatchItems = flatSelectedItems;
            cartData.unitPrice = Number(data?.calculated_price ?? data?.price ?? data?.unit_price ?? 0);

            let cachedMixAndMatchItem = null;
            try {
                const raw = typeof window !== "undefined" && window?.sessionStorage ? sessionStorage.getItem("mix_and_match_menu_items") : null;
                if (raw) {
                    const parsed = JSON.parse(raw);
                    if (Array.isArray(parsed)) {
                        cachedMixAndMatchItem = parsed.find(mi => 
                            String(mi.id) === String(data?.id) || 
                            String(mi.id) === String(data?.menu_item?.id) || 
                            (mi?.name && data?.name && String(mi.name).toLowerCase().trim() === String(data.name).toLowerCase().trim())
                        );
                    }
                }
            } catch (e) {
                // ignore
            }

            const fullCategories = (Array.isArray(cachedMixAndMatchItem?.categories) && cachedMixAndMatchItem.categories.length > 0)
                ? cachedMixAndMatchItem.categories
                : (Array.isArray(data?.categories) && data.categories.length > 0
                    ? data.categories
                    : (data?.item?.categories || []));

            cartData.data.item.categories = fullCategories;

            const totalItemCount = flatSelectedItems.reduce((sum, it) => sum + (Number(it.quantity) || 1), 0);
            const parsedNumberFromName = data?.name ? (data.name.match(/\b(\d+)\b/)?.[1] ? Number(data.name.match(/\b(\d+)\b/)[1]) : null) : null;

            cartData.data.item.max_choose = Number(
                cachedMixAndMatchItem?.max_choose ||
                data?.max_choose ||
                data?.item?.max_choose ||
                (parsedNumberFromName && parsedNumberFromName > 0 ? parsedNumberFromName : null) ||
                (totalItemCount > 0 ? totalItemCount : 1)
            );
        }

        cartData.data.variant = data?.variant || null;
        // console.log(data);

        cart.push(cartData);

    })





    return({
        cart, 
        orderType, 
        customer, 
        delivery, 
        source: backendData?.source || null, 
        table_id: backendData?.table_id || null
    })
}


export default BackendToCartDataFormat;